import { get } from './common';

import { validate } from './validation';
import { InstrumentDTO } from '../dto/instrument';

export const getInstrument = async (instrumentId: string): Promise<InstrumentDTO> => {
  const templates = await get('/instrument', { instrumentId }).then(response => response.data);
  return validate(InstrumentDTO, templates);
};
